<script lang="ts" setup>
import { ref, watch } from 'vue'
import { useBreakpoints } from '@/lib/utils'
import BsSide from '@/legacy/components/Side.vue'
import BsDrawerPanel from '@/legacy/components/DrawerPanel.vue'

const { isLarge: isDesktop } = useBreakpoints()
const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	title: {
		type: String,
		default: '',
	},
	isShowTrailing: {
		type: Boolean,
		default: false,
	},
	isShowBackIcon: {
		type: Boolean,
		deafult: false,
	},
})

const emit = defineEmits(['input', 'on-hide', 'update:modelValue'])
const isShow = ref(false)

function show() {
	emit('update:modelValue', true)
}
function hide() {
	emit('update:modelValue', false)
	emit('on-hide')
}

watch(
	() => props.modelValue,
	val => {
		isShow.value = val
	},
	{
		immediate: true,
	},
)

watch(
	() => isShow.value,
	val => {
		if (val) show()
		else hide()
	},
)
</script>

<template>
	<div class="bs-side-drawer">
		<BsSide
			v-if="isDesktop"
			v-model="isShow"
			:title="title"
			:isShowBackIcon="isShowBackIcon"
		>
			<template v-if="isShowTrailing" v-slot:title-trailing>
				<slot name="title-trailing"></slot>
			</template>
			<slot />
		</BsSide>
		<BsDrawerPanel v-else v-model="isShow" :title="title">
			<template v-if="isShowTrailing" v-slot:title-trailing>
				<slot name="title-trailing"></slot>
			</template>
			<slot />
		</BsDrawerPanel>
	</div>
</template>
